// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import { IStateIdList } from "./states";
import { ConnectorStatus } from "model/connector";
import type { ITrendWindow } from "model/trendwindow";
import { ChargerStatusNotificationSource } from "graphql/api";

export interface ITrendDataRow {
  timestamp: number; // s, fractional
  tlId: number;
  regperiod: number;
  energy: number;
  power: number;
  costs?: number;
  tariff?: number;
  targetpower?: number;
  // only for charger trending
  soc?: number;
}
export type ITrendData = ITrendDataRow[];

export type IIoTrendIos = number[]; // array index: input/output index
export type IIoTrendTimestamp = IIoTrendIos[]; // array index: 0..input, 1..output

export interface IIoTrend {
  [timestamp: number]: IIoTrendTimestamp; // timestamp in s
}
export type IIoTrendCounts = number[];
export type IIoTrendCountsTimestamp = IIoTrendCounts[]; // array index: output index
export interface IIoTrendCount {
  [timestamp: number]: IIoTrendCountsTimestamp; // timestamp in s
}

export interface IChargerStateEvent {
  id: number;
  fk_charger: number;
  connector: number;
  timestamp: number;
  source: ChargerStatusNotificationSource;
  statusCode: ConnectorStatus;
  errorCode: string;
  info: string | undefined;
}

export interface IStateTrending {
  trendData: ITrendData;
  ioTrendAggr: IIoTrend;
  ioTrendFull: IIoTrend;
  ioTrendCount: IIoTrendCount;
  isIoTrendRestricted: boolean;
  queryMoreData: boolean;

  loadedTrendWindow?: ITrendWindow; // range and aggregation of trendData
  minTrendTimestamp?: number | undefined;
  maxTrendTimestamp?: number | undefined; // s
  minIoTimestamp?: number | undefined;
  maxIoTimestamp?: number | undefined;

  // only available in cloud
  chargerTrend?: IStateIdList<ITrendData>; // charger_fk as idList key
  chargerStateData?: IChargerStateEvent[];
}

/* initial state */
export const INITIAL_STATE: IStateTrending = {
  trendData: [],
  ioTrendAggr: {},
  ioTrendFull: {},
  ioTrendCount: {},
  isIoTrendRestricted: false,
  queryMoreData: false,
};
